import React from 'react';
import { Typography, Modal, Button } from '@hpstellar/core/visId';
import RelatedOffersCarousel from '../related-offers-carousel';
import useOfferByCalcCode from './useOfferByCalcCode';
import { Helpers } from '../../../../../../core';

import './offer-modal.less';

const OfferContent = ({ offer, subtite }) => {
    const offerDetails = useOfferByCalcCode(offer);
    const { AssociatedCatentryDetails: relatedOfferProducts, longDescription } = offerDetails || {};

    return (
        <div className={`offer-detailspopup ${relatedOfferProducts ? 'prod-carousel' : ''}`}>
            {offer.name && (
                <Typography variant="h5" className="title">
                    {offer.name}
                </Typography>
            )}
            {longDescription && (
                <Typography
                    tag="div"
                    variant="body1"
                    className="desc"
                    dangerouslySetInnerHTML={Helpers.createMarkup(longDescription)}
                />
            )}
            {(relatedOfferProducts || offer.productOfferLink) && !relatedOfferProducts && (
                <Typography variant="h5" className="subtitle">
                    {subtite}
                </Typography>
            )}
            {relatedOfferProducts && (
                <>
                    <RelatedOffersCarousel />
                </>
            )}

            {offer.productOfferLink && (
                <>
                    <Button className="product-url" to={offer.productOfferLink.url} variation="tertiary">
                        {offer.productOfferLink.name}
                    </Button>
                </>
            )}
        </div>
    );
};

const OfferModal = ({
    animationType = '',
    horizontalAlignment = 'center',
    isOpen,
    onClose,
    modalTitle,
    withBackdrop = 'backdrop-none',
    modalOffer,
    className = 'pdp-offer-modal',
    modalSubTitle = 'Offer also applies to:',
}) => {
    return (
        <Modal
            animationType={animationType}
            horizontalAlignment={horizontalAlignment}
            isOpen={isOpen}
            className={className}
            onClose={onClose}
            modalClassName="offers-modal"
            backdropClassName={withBackdrop}
            title={modalTitle}
        >
            <OfferContent offer={modalOffer} subtite={modalSubTitle} />
        </Modal>
    );
};

export default OfferModal;
